import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ToastService } from '../../core/services/toast.service';
import { RestResponse } from '../../core/rest-response';
import { UserService } from '../../domain/user/service/user.service';

@Component({
  selector: 'app-home',
  imports: [],
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss'
})
export class MainComponent {
  private readonly router = inject(Router);
  private readonly userService = inject(UserService);
  private readonly toast = inject(ToastService);

  goToSignin() {
    this.router.navigate(['/signin']);
  }

  goToSignup() {
    this.router.navigate(['/signup']);
  }

  checkPermission() {
    this.userService.jwtTest().subscribe({
      next: (result: RestResponse) => {
        if (result.success) {
          this.toast.show(result.data);
        } else {
          this.router.navigate(['/signin/verify']);
          this.toast.show('서비스를 이용하려면 본인 확인이 필요합니다.');
        }
      },
      error: () => {
        this.router.navigate(['/signin']);
        this.toast.show('서비스를 이용하려면 로그인이 필요합니다.');
      }
    });
  }
}
